import { Skeleton } from "@material-ui/lab";
import Card from "../../../../../components/card";
import { Div, Container } from "../../style";

const Loading = () => {
  return (
    <>
      {[0, 1, 2].map((key) => (
        <Container key={key}>
          <Card className="p-2 py-3 text-right mb-2">
            <Div>
              <Div className="mt-1 d-inline-block">
                <Skeleton
                  className="d-inline-block transform-y-0"
                  width={70}
                  height={70}
                  animation="wave"
                />
              </Div>
              <Div className="mt-1 d-inline-block vertical-align-top mr-3">
                <Div>
                  <Skeleton width={140} animation="wave" />
                </Div>
                <Div>
                  <Skeleton
                    className="d-inline-block"
                    width={15}
                    animation="wave"
                  />
                  <Skeleton
                    className="d-inline-block mr-1"
                    width={55}
                    animation="wave"
                  />
                  <Skeleton
                    className="d-inline-block mx-3"
                    width={1}
                    animation="wave"
                  />
                  <Skeleton
                    className="d-inline-block"
                    width={15}
                    animation="wave"
                  />
                  <Skeleton
                    className="d-inline-block mr-1"
                    width={30}
                    animation="wave"
                  />
                </Div>
                <Div>
                  <Skeleton
                    className="transform-y-0 d-inline-block"
                    height={15}
                    width={15}
                    animation="wave"
                  />
                  <Skeleton
                    className="transform-y-0 d-inline-block mr-1"
                    height={15}
                    width={170}
                    animation="wave"
                  />
                </Div>
              </Div>
              <Div className="mt-3">
                <Skeleton
                  className="transform-y-0 d-inline-block mx-2"
                  height={15}
                  width="5%"
                  animation="wave"
                />
                <Skeleton
                  className="transform-y-0 d-inline-block vertical-align-super"
                  height={5}
                  width="30%"
                  animation="wave"
                />
                <Skeleton
                  className="transform-y-0 d-inline-block mx-2"
                  height={15}
                  width="5%"
                  animation="wave"
                />
                <Skeleton
                  className="transform-y-0 d-inline-block vertical-align-super"
                  height={5}
                  width="30%"
                  animation="wave"
                />
                <Skeleton
                  className="transform-y-0 d-inline-block mx-2"
                  height={15}
                  width="5%"
                  animation="wave"
                />
              </Div>
              <Div className="mt-2">
                <Skeleton
                  className="transform-y-0 d-inline-block"
                  height={15}
                  width={100}
                  animation="wave"
                />
                <Skeleton
                  className="transform-y-0 d-inline-block ml-3 float-left"
                  height={15}
                  width={50}
                  animation="wave"
                />
              </Div>
              <Div className="mt-1">
                <Skeleton
                  className="transform-y-0 d-inline-block"
                  height={40}
                  width="100%"
                  animation="wave"
                />
              </Div>
            </Div>
          </Card>
        </Container>
      ))}
    </>
  );
};

export default Loading;
